import React from 'react';
import { Row, Col } from "antd";
import { NormalizedUsageChart } from './components/NormalizedUsageChart';
import { MonthlyUsageBaselineChart } from './components/MonthlyUsageBaselineChart';
import { MonthlyCostSavingsChart } from './components/MonthlyCostSavingsChart';
import { CumulativeCostSavingsChart } from './components/CumulativeCostSavingsChart';

const contentStyle = {
    height: '100%',
    background: '#fff',
    borderRadius: 8,
    border: '1px solid #f0f0f0',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
    padding: '8px',
    aspectRatio: '4 / 3'
}

const colLayout = {
    xs: 24,
    lg: 12,
    xxl: 8,
    style: { padding: '6px' }
}

export const SavingCharts = ({
    NormalizedElec,
    NormalizedGas,
    MonthlyElec,
    MonthlyGas,
    MonthlyCost,
    CumulativeCost
}) => {
    return (
        <Row gutter={[0, 0]} style={{ margin: '-6px' }}>
            <Col {...colLayout}>
                <div style={contentStyle}>
                    <NormalizedUsageChart type='elec' {...NormalizedElec} />
                </div>
            </Col>
            <Col {...colLayout}>
                <div style={contentStyle}>
                    <NormalizedUsageChart type='gas' {...NormalizedGas} />
                </div>
            </Col>
            <Col {...colLayout}>
                <div style={contentStyle}>
                    <MonthlyCostSavingsChart {...MonthlyCost} />
                </div>
            </Col>
            <Col {...colLayout}>
                <div style={contentStyle}>
                    <MonthlyUsageBaselineChart type='elec' {...MonthlyElec}/>
                </div>
            </Col>
            <Col {...colLayout}>
                <div style={contentStyle}>
                    <MonthlyUsageBaselineChart type='gas' {...MonthlyGas} />
                </div>
            </Col>
            <Col {...colLayout}>
                <div style={contentStyle}>
                    <CumulativeCostSavingsChart {...CumulativeCost} />
                </div>
            </Col>
        </Row>
    );
}
